import type { SVGProps } from 'react'

export const ImageCompany = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={32} width={32} viewBox="0 0 32 32" {...props}>
    <path d="M30.715.156h-2.664l-.931 20.989-8.441-3.595v4.012L9.34 17.55v4.012L-.031 17.55v14.699h32.094zM9.34 28.367H2.632v-2.664H9.34zm9.339 0h-6.676v-2.664h6.676zm9.372 0h-6.676v-2.664h6.676z" />
  </svg>
)
